import axios from "axios"

export const httpClient = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
  withCredentials: true,
})

export const publicHttpClient = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
  withCredentials: false,
})
